import { speed } from 'Lib/speed/speed';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import 'Vendor/owlcarousel/owl.carousel.min';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';
import { isObject } from 'Lib/is-object/is-object';

const $slider = $('.personages-slider__slider');
const $previewSlider = $('.personages-slider__preview');
const sPreviewItem = '.personages-slider__preview-item';
const cSliderOn = 'owl-carousel';
let lastStateIsMobileScreen = isMobileScreen();
const slideSpeed = speed * 2;
const sSliderPic = '.personage__pic';

function isMobileScreen() {
    return (getW() < eksmoBP.smMin);
}

function loadPicsOnSlider(e) {
    onScreen(isObject(e) ? $(e.target).find(sSliderPic) : $(sSliderPic), loadSrcOrBg);
}

function loadPicsOnPreviewSlider(e) {
    onScreen($(e.target).find('.personages-slider__preview-item-pic'), loadSrcOrBg);
}

function setSliders() {
    if (isMobileScreen()) {
        $slider.trigger('destroy.owl.carousel');
        loadPicsOnSlider();
    } else {
        $slider.each(function () {
            $(this).trigger('destroy.owl.carousel')
                .removeClass(cSliderOn)
                .addClass(cSliderOn)
                .owlCarousel({
                    smartSpeed: slideSpeed,
                    nav: true,
                    dots: false,
                    items: 1,
                    slideBy: 1,
                    margin: 0,
                    navClass: ['personages-slider__arrow-prev arrow arrow_shadow arrow_prev', 'personages-slider__arrow-next arrow arrow_shadow arrow_next'],
                    navText: ['', ''],
                    onInitialized: loadPicsOnSlider,
                    mouseDrag: false,
                    onTranslate: onSlideTo,
                });
        });

        $previewSlider.each(function () {
            $(this).trigger('destroy.owl.carousel')
                .removeClass(cSliderOn)
                .addClass(cSliderOn)
                .owlCarousel({
                    smartSpeed: slideSpeed,
                    dots: false,
                    autoWidth: true,
                    margin: 0,
                    loop: true,
                    onInitialized: loadPicsOnPreviewSlider,
                    mouseDrag: false,
                });
        });
    }
}

function onSlideTo(e) {
    if (!isMobileScreen()) {
        $previewSlider.trigger('to.owl.carousel', [e.item.index]);
    }
}

function slideTo(index) {
    $slider.trigger('to.owl.carousel', [index, 0]);
    $previewSlider.trigger('to.owl.carousel', [index]);
}

setSliders();

$('body').on('eksmoResizeWidth', () => {
    if (isMobileScreen() !== lastStateIsMobileScreen) {
        setSliders();
        lastStateIsMobileScreen = isMobileScreen();
    }
});

$previewSlider.on('click', sPreviewItem, function () {
    const $this = $(this);
    const num = $this.attr('data-num');

    if (isNoEmptyString(num)) {
        slideTo(parseInt(num));
    }
});